import { useCallback } from "react";

import Input, { type InputProps } from "@snapchat/snap-design-system/es/components/Input";
import { type FormFieldProps } from "@snapchat/snap-design-system/es/shared/types";

type NumberInputProps = Omit<InputProps, keyof FormFieldProps<string>> & FormFieldProps<number>;

export const NumberInput = (props: NumberInputProps) => {
    const { defaultValue, value, onChange, ...restProps } = props;

    const onChangeNumber = useCallback(
        (newValue: string) => {
            const parsedValue = Number.parseInt(newValue, 10);

            if (!Number.isNaN(parsedValue)) {
                onChange?.(parsedValue);
            }

            if (newValue === "") {
                onChange?.(defaultValue);
            }
        },
        [defaultValue, onChange],
    );

    const defaultValueString = defaultValue?.toString();
    const valueString = value?.toString();

    return <Input {...restProps} defaultValue={defaultValueString} value={valueString} onChange={onChangeNumber} />;
};
